import { Table } from '@loadsmart/loadsmart-ui'

import { type RfpSummary } from '../domain/RfpSummary'
import { EmptyRfpHistoryState } from './EmptyRfpHistoryState'
import { RfpListItem } from './RfpSummaryListItem'

export type RfpLaneListProps = {
  rfpHistory: Array<RfpSummary>
}

export function RfpSummaryList({ rfpHistory }: RfpLaneListProps) {
  if (rfpHistory.length <= 0) return <EmptyRfpHistoryState />

  return (
    <Table scale="large">
      <Table.Head>
        <Table.Row>
          <Table.HeadCell>Rfp Title</Table.HeadCell>
          <Table.HeadCell>Shipper</Table.HeadCell>
          <Table.HeadCell>Bid status</Table.HeadCell>
          <Table.HeadCell>Contract</Table.HeadCell>
          <Table.HeadCell>Lanes</Table.HeadCell>
          <Table.HeadCell>Bids</Table.HeadCell>
          <Table.HeadCell>Awards</Table.HeadCell>
          <Table.HeadCell>Deadline</Table.HeadCell>
          <Table.HeadCell>Action</Table.HeadCell>
        </Table.Row>
      </Table.Head>
      <Table.Body>
        {rfpHistory.map(item => (
          <RfpListItem key={item.inviteLinkUuid} rfpSummary={item} />
        ))}
      </Table.Body>
    </Table>
  )
}
